import script from "./EncounterNotesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EncounterNotesTable.vue?vue&type=script&setup=true&lang=js"

import "./EncounterNotesTable.vue?vue&type=style&index=0&id=0c9dd0f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9dd0f9"]])

export default __exports__